<template>
  <v-container>
    <Loader v-if="isLoading" />
    <b-table
      v-else-if="!isLoading"
      :data="blockRewards"
      class="table"
    >
      <template slot-scope="props">
          <b-table-column field="block_meta.header.height" label="Number">
            <router-link
              class="router-link"
              :to="{ name: 'block', params: {blockNumber: props.row.block_meta.header.height}}"
            >
              {{ props.row.block_meta.header.height }}
            </router-link>
          </b-table-column>

          <b-table-column field="txns" label="Txns">
            <router-link
              class="router-link"
              :to="{ name: 'blockTransactions', params: {blockNumber: props.row.block_meta.header.height }}"
            >
              {{ props.row.block_meta.header.num_txs }}
            </router-link>
          </b-table-column>

          <b-table-column field="timeStamp" label="Time">
            <v-tooltip bottom>
              <span slot="activator">
                <timeago :datetime="props.row.block_meta.header.time" :auto-update="10">
                </timeago>
              </span>
              <span>{{ new Date(props.row.block_meta.header.time).toISOString() }}</span>
            </v-tooltip>
          </b-table-column>

          <b-table-column field="hash" label="Hash">
            {{ props.row.block_meta.block_id.hash }}
          </b-table-column>

      </template>
  </b-table>
  <el-pagination
    background
    :current-page="current_page"
    @current-change="shift"
    @prev-click="shift(current_page-1)"
    @next-click="shift(current_page+1)"
    layout="prev, pager, next"
    :pager-count=5
    :page-size="pageSize"
    :total="totalBlockRewards">
  </el-pagination>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '../reusables/loader.vue';

export default {
  name: 'BlockRewards',
  data() {
    return {
      current_page: 1,
      pageSize: 20,
      isLoading: false,
    };
  },
  components: {
    Loader,
  },
  watch: {
    blocks() {
      this.isLoading = false;
    },
  },
  methods: {
    shift(page) {
      this.isLoading = true;
      this.$store.dispatch('fetchBlockRewards', {
        limit: this.pageSize,
        page,
      });
      this.current_page = page;
      this.$router.push({ path: this.$route.path, query: { page } });
    },
  },
  computed: {
    ...mapGetters(['blockRewards', 'totalBlockRewards']),
  },
  created() {
    this.shift(this.$route.query.page);
  },
};
</script>

